let flagStore: Record<string, boolean> = {};

/**
 * Appends any `flag_*` query search params to the current flag store.
 *
 * The flag value will be set to true if the flag is assigned any of the
 * following values: 1, y, yes, t, or true.
 */
export function captureFlags() {
  const currentParams = new URLSearchParams(window.location.search);
  currentParams.forEach((value, key) => {
    const k = key.toLowerCase();
    if (!k.startsWith("flag_")) {
      return;
    }

    flagStore[k] = ["1", "y", "yes", "t", "true"].includes(
      (value || "0").toLowerCase()
    );
  });
}

/**
 * Clear the flag store, removing all previously captured flags.
 */
export function resetAllFlags() {
  flagStore = {};
}

/**
 * Evaluate the truthiness of the specified flag.
 * @param name - name of the flag to evaluate, e.g. "flag_foo".
 * @returns Truthiness of the specified flag.
 */
export function checkFlag(name: string): boolean {
  return flagStore[name] ?? false;
}
